import { useEffect } from "react";
import "./App.css";

// Impor statis hanya untuk SectionHero (above-the-fold)
import { SectionHero } from "./sections/SectionHero";
import { SectionAboutTracking } from "./sections/SectionAboutTracking";
import { SectionContact } from "./sections/SectionContact";

export const Beranda = () => {
  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    if (hash) {
      requestAnimationFrame(() => {
        document.getElementById(hash)?.scrollIntoView({ behavior: "smooth" });
      });
      return;
    }

    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {/* Above-the-fold: Langsung dirender */}
      <SectionHero />
      <SectionAboutTracking />
      <SectionContact />
    </div>
  );
};
